// import library
import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { env } from "../../env";
import OrderViewWithPrice from "../../components/Order/Customer/OrderViewWithPrice";
import OrderViewBasic from "../../components/Order/Customer/OrderViewBasic";

const OrderView = () => {
    // variables
    const location = useLocation();
    const orderid = location.pathname.split('/')[3];
    const [customerData, setCustomerData] = useState({});
    const baseUrl = env.REACT_APP_API_URL;
    const token = localStorage.getItem('token');

    // functions
    useEffect(() => {
        const fetchData = async () => {
            try {
                await Promise.all([
                    getOrderDetailDataApi(baseUrl, token),
                ]);
            } catch (error) {
                console.error("Error fetching data", error);
            }
        };
    
        fetchData();
    }, [baseUrl, token]);

    // api
    const getOrderDetailDataApi = async (url, token) => {
        axios.get(url + "/api/Product/GetCustomerOrderDetail?orderid="+orderid, {
            headers: {
                "Accept" : "Application/json",
                "Content-Type" : "Application/json",
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            if(response.data) {
                getCustomerDataApi(url, token, response.data.customerID);
            }
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        })
    };
    const getCustomerDataApi = async (url, token, id) => {
        axios.post(url + "/api/Customer/GetCustomerDetail", { customerid: id }, {
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            if (response.data.length > 0) {
                setCustomerData(response.data[0]);
            }
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        })
    };

    return (
        <>
            {customerData.showPrices 
                ? 
                    <OrderViewWithPrice />
                :
                    <OrderViewBasic />
            }
        </>
    )
}

export default OrderView